import {useState, useEffect, useContext} from 'react'

import {PuzzleChangeContext} from '../../../../context/PuzzleChangeContext'
import settings from '../machineSettingsData'

function useTimer() {
    const {machineAddTime} = useContext(PuzzleChangeContext)
    const [originalTimeLimit] = useState(settings.maxTime)
    const [maxTime, setMaxTime] = useState(originalTimeLimit)
    const [startMachine, setStartMachine] = useState(false)
    const [timeRemaining, setTimeRemaining] = useState(maxTime)
    const [timeToOverheat, setTimeToOverheat] = useState(() => Math.floor((Math.random() * (maxTime * 0.5)) + 30)) 
    const [overheatMaxCountdown] = useState(settings.overheatMaxCountdown)
    const [overheating, setOverheating] = useState(false)
    const [overheatCountdown, setOverheatCountdown] = useState(overheatMaxCountdown)
    const [resetGame, setResetGame] = useState(true)
    
    useEffect(() => {
        machineAddTime > maxTime && setTimeRemaining(0)
        machineAddTime && setMaxTime(prevTime => prevTime + machineAddTime)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [machineAddTime])
        
    useEffect(() => {
        if (startMachine) {
            const timer = setTimeout(() => {
                if (timeRemaining > 0) { 
                    setTimeRemaining(prevTime => prevTime - 1) 
                } else {
                    setResetGame(true)
                    const newMaxTime = Math.floor(maxTime + 0.1 * originalTimeLimit)
                    console.log('old max time: ' + maxTime)
                    console.log('new max time: ' + newMaxTime)
                    console.log('adjustment: ' + (0.1 * originalTimeLimit))
                    setMaxTime(newMaxTime)
                }
            }, 1000)
            
            return () => clearTimeout(timer)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeRemaining, startMachine])
    
    useEffect(() => {
        if (startMachine) {
            const timer = setTimeout(() => {
                if (timeToOverheat > 0) {
                    setTimeToOverheat(prevTime => prevTime - 1) 
                } else if (overheatCountdown > 0) {
                    setOverheatCountdown(prevTime => prevTime - 1)
                } 
            }, 1000)

            return () => clearTimeout(timer) 
        }
    }, [timeToOverheat, overheatCountdown, startMachine])
    
    useEffect(() => {
        timeToOverheat <= 0 && setOverheating(true)
    }, [timeToOverheat])
    
    useEffect(() => { 
        overheatCountdown <= 0 && setOverheating(false)
    }, [overheatCountdown])
    
    useEffect(() => {
        startMachine ? setResetGame(false) : setTimeRemaining(maxTime)
    }, [startMachine, maxTime])
    
    useEffect(() => {
        if (resetGame) { 
            setStartMachine(false)
            setOverheating(false)
            setOverheatCountdown(overheatMaxCountdown)
            setTimeToOverheat(() => Math.floor((Math.random() * (maxTime * 0.5)) + 30))
        }
    }, [resetGame, overheatMaxCountdown, maxTime])
    
    return {
        timeRemaining,
        maxTime,
        overheating, 
        setOverheating, 
        overheatCountdown,
        startMachine,
        setStartMachine,
        resetGame,
        setResetGame
    }
}

export default useTimer